import Smiley from "./Smiley";
import "./SmileyBar.scss";

export default function () {
  return (
    <>
      <div className="Smiley-bar-spacer"></div>
      <div className="Smiley-bar">
        <Smiley />
        <Smiley />
        <Smiley />
        <Smiley />
        <Smiley />
        <Smiley />
      </div>
    </>
  );
}
